import * as Yup from "yup";

import { TextManager } from "Components/TextContext";
import { BooleanFormType } from "Store/interfaces/FormTypes";
import {
  ChildCoverage,
  ChildHealthCoverage,
} from "Store/interfaces/products/coverage";
import { ChildPriceFormValues } from "./childProductPriceInterfaces";

export const validationSchema =
  () => (): Yup.ObjectSchema<ChildPriceFormValues> => {
    const { getText } = TextManager;
    return Yup.object({
      coverage: Yup.mixed<ChildCoverage>()
        .oneOf(Object.values(ChildCoverage))
        .required(getText("childform.validation.coverage")),
      buyChildHealthInsurance: Yup.boolean().required(),
      relatedChildHealthProductId: Yup.string().notRequired(),
      childHealthCoverage: Yup.mixed<ChildHealthCoverage>().when(
        "buyChildHealthInsurance",
        {
          is: true,
          then: (schema) => schema.required(),
        },
      ),
      ergoConsent: Yup.mixed<BooleanFormType>().when(
        ["buyChildHealthInsurance", "relatedChildHealthProductId"],
        {
          is: (
            buyChildHealthInsurance: boolean,
            relatedChildHealthProductId: string,
          ) => buyChildHealthInsurance && !relatedChildHealthProductId,
          then: (schema) =>
            schema.required(getText("childform.validation.ergoconsent")),
          otherwise: (schema) => schema.notRequired(),
        },
      ),
    }).defined();
  };
